import styled from 'styled-components';

import { mediaConfined, mediaWideNavless, zIndexStickyLayer3 } from '@xingternal/layout-tokens';
import { spaceL, xdlColorBackground, xdlColorBorderSoft } from '@xingternal/tokens';
import { Row } from '@xingternal/xing-grid';

import { ActionsContainer } from '@/components/posting-header-actions';
import { HEADER_HEIGHT, HEADER_HEIGHT_MOBILE, HEADER_HEIGHT_MOBILE_LOGOUT } from '@/config';

export const StyledStickyHeader = styled.div<{ $width: number; $isLoggedIn: boolean }>`
  position: fixed;
  width: ${({ $width }) => ($width ? $width : 0)}px;
  z-index: ${zIndexStickyLayer3 - 1};
  top: ${({ $isLoggedIn }) => ($isLoggedIn ? `${HEADER_HEIGHT_MOBILE}` : `${HEADER_HEIGHT_MOBILE_LOGOUT}`)}px;

  @media ${mediaConfined} {
    top: ${({ $isLoggedIn }) => ($isLoggedIn ? `${HEADER_HEIGHT_MOBILE}` : `${HEADER_HEIGHT}`)}px;
  }

  @media ${mediaWideNavless} {
    top: ${HEADER_HEIGHT}px;
  }
`;

export const StickyHeaderMobileRow = styled(Row)`
  background-color: ${xdlColorBackground};
  border-bottom: 1px solid ${xdlColorBorderSoft};
`;

export const StickyActionButtons = styled(ActionsContainer)`
  padding-bottom: ${spaceL};
  width: 100%;
`;
